// Inner padding of the task-card content. The section header reuses this (plus a
// STRIPE_WIDTH spacer) to line its number up with the task numbers structurally,
// instead of a hand-tuned indent that drifts when the stripe/padding change.
export const TASK_CARD_CONTENT_PADDING = 4;
